module.exports = __webpack_public_path__ + "static/media/smartbilling.4dcfa951.svg";